import { render, staticRenderFns } from "./BrandsContainer.vue?vue&type=template&id=daf297ec&"
import script from "./BrandsContainer.vue?vue&type=script&lang=js&"
export * from "./BrandsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports